import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12.931 12.112c1.476-1.475 1.993-1.966 2.129-2.027.418-.188.961-.053 1.215.304.241.338.252.825.025 1.15-.173.247-4.72 4.763-4.88 4.848-.194.101-.686.101-.88 0s-2.3-2.203-2.433-2.426c-.091-.152-.107-.226-.107-.48s.017-.328.108-.483a1 1 0 0 1 1.215-.45c.166.056.312.18.928.788l.732.721z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 3a2 2 0 0 0-2 2v13a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-7.625L11.35 3.739A2 2 0 0 0 9.798 3zm0 4v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z",
      clipRule: "evenodd"
    }
  )
);
var SvgFolderCheckedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FolderCheckedOutlined_default = SvgFolderCheckedOutlined;

export { FolderCheckedOutlined_default as default };
